var map = {
	"./256.png": 7555,
	"./Shippy_hero.png": 1980,
	"./background-image.jpg": 8064,
	"./customized_graphical_user_interface.png": 6446,
	"./customized_gui.png": 5563,
	"./east-west-gallery.webp": 5575,
	"./garn_tygladan_vinnersjo.jpg": 5640,
	"./garn_tygladan_vinnersjo_portfolio.png": 3348,
	"./jonas.webp": 5494,
	"./logo.png": 4427,
	"./nordiska_vvs_mobile.jpg": 5665,
	"./payment_card_klarna.png": 4321,
	"./photo_2023-11-08_12-18-15.jpg": 782,
	"./photo_2023-11-08_12-47-19.jpg": 3598,
	"./product_management.png": 4246,
	"./recommended_tasks.jpg": 6539,
	"./stock_management.png": 4440,
	"./stock_management_img.png": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8977;